import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import GetInTouchFooter from "./GetInTouchFooter";
import CustomGalleryModal from "./custom/CustomGalleryModal";
import CustomButton from "./custom/CustomButton";
import axiosStrapiInstance from "../axiosStrapi";
import { toast } from "react-toastify";
import Loader from "./custom/Loader";
import { baseUrl } from "../axiosStrapi";
import { headerImages } from "../utils/constants";
import { Helmet } from "react-helmet";

const PositiveParenting = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPositiveParenting();
    const timer = setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  async function getPositiveParenting() {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get(
        "/api/website-images?filters[Type][$eq]=PositiveParenting&populate=*"
      );
      setImages(response?.data?.data[0]?.images);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      } else {
        toast.error("Login failed");
      }
    }
  }
  return (
    <div>
      <Helmet>
        <title>Parenting Expert |Positive parenting |Parenting Expert in India| Sudha Gupta</title>
        <meta name="description" content="Positive parenting by sudha gupta, Parenting Expert, Parenting expert in India, Positive Parenting, Mother’s Pride, Parenting Tips, Expert of Parenting." />
        <meta name="keywords" content="Parenting Expert,Positive parenting" />
        <link rel="canonical" href="https://www.motherspridepreschool.com/positiveParenting" />
      </Helmet>
      <div className="overflow-x-hidden">
        <img
          src={
            window.innerWidth < 450
              ? headerImages.mobilePositiveParentingHeaderImg
              : window.innerWidth < 900
              ? headerImages.tabPositiveParentingHeaderImg
              : headerImages.positiveParentingHeaderImg
          }
          alt="positive parenting"
          className="overflow-x-hidden absolute w-[100vw] h-[300px] lg:h-[420px] "
        />
        <div className="px-[4%] 2xl:px-[6%] flex flex-col gap-10 ">
          {/* main img */}

          <div className="flex flex-col gap-3 mt-[320px] sm:mt-[320px] lg:mt-[450px]">
            <h1 className="">
              <span className="text-[#383838] font-Wonderbar text-[36px] sm:text-[63px] font-bold leading-[40px] sm:leading-[78.12px]">
                Positive Parenting{" "}
              </span>
              <span className="text-[#d31c4f] lg:inline capitalize hidden text-[20px] sm:text-[42px] font-normal font-Lato  leading-6 sm:leading-[52.08px]">
                // a life-changing Experience
              </span>
            </h1>

            <p className="text-[#d31c4f] text-xl sm:text-2xl font-normal font-Lato  leading-7 sm:leading-[33.60px]">
              Parenting is not just about raising children, it's about raising
              parents too.
              <br />
            </p>
          </div>
          <div className="text-[#101010] text-base sm:text-2xl font-normal font-Lato  leading-6 sm:leading-[38.40px]">
            Positive Parenting is a cause deeply cherished by our Chairperson,
            Mrs. Sudha Gupta. She regularly conducts engaging and transformative
            parenting seminars for the parents of our children. These sessions
            are not just educational but vibrant and full of life, leaving a
            lasting impact on those who attend. Many parents have openly shared
            that the experience was life-changing, moving them to both laughter
            and tears. Thousands of parents have benefited from these seminars,
            and through them, countless children have experienced the positive
            ripple effects of enlightened and empowered parenting.
            <p className="text-[#101010] mt-2 text-base sm:text-2xl font-normal font-Lato leading-6 sm:leading-[38.40px]">
              Follow her on{" "}
              <a
                className="underline text-blue-800 break-words"
                target="blank"
                href="https://www.instagram.com/positiveparentingbysudhagupta/#"
              >
                Instagram
              </a>{" "}
              for valuable parenting insights and inspiration!
            </p>
          </div>

          {/* view parenting tips button */}
          <CustomButton
            width="250px"
            marginTop="0px"
            text={"View Parenting Tips"}
            paddingX="20px"
            paddingY="12px"
            handleClick={() => window.open("/parentingTips", "_self")}
          />

          {/* PositiveparentingImages */}
          {loading ? (
            <Loader />
          ) : (
            <CustomGalleryModal
              paddingX={"0%"}
              paddingY={"0%"}
              scroll={true}
              images={images?.map((item) => `${item?.url}`)}
            />
          )}

          <GetInTouchFooter marginX={"0%"} />

          {/* Footer */}
          <div>
            <Footer marginX={"0%"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PositiveParenting;
